import React from "react";

import "../css/bird.css";

function Bird() {
	return <div id="bird" />;
}

export default Bird;